import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { ROLE_OPTIONS } from "../utils/roles";

// Shows every role of a dashboard user as a colored chip, plus an edit button.
function UserRole({ roles, disabled, onEdit }) {
  return (
    <div className="flex flex-wrap items-center gap-1 py-1">
      {ROLE_OPTIONS.filter((option) => roles.includes(option.value)).map(
        (option) => (
          <span
            key={option.value}
            style={{ backgroundColor: option.color }}
            className="rounded px-2 py-[2px] text-[12px] text-[white]"
          >
            {option.label}
          </span>
        )
      )}
      {!disabled && (
        <button
          type="button"
          onClick={onEdit}
          title="Edit roles"
          className="ml-1 rounded px-[6px] py-[2px] text-[12px] text-[#0388CC] bg-[#E9F6FD] hover:bg-[#d3edfb]"
        >
          <FontAwesomeIcon icon={faPen} />
        </button>
      )}
    </div>
  );
}

export default UserRole;
